import React, { useState } from 'react'
import { Card, CardHeader, CardBody, Container, Flex, FormControl, FormLabel, Image, Input, CardFooter, Button, Heading, useToast } from '@chakra-ui/react'
import { login } from '../../api'
import LogoV2 from '../../assets/images/logo-v2.png'
import { useNavigate } from 'react-router-dom'
import { saveToken } from 'lib/localStorage'

export const Login = () => {
  const toast = useToast()
  const navigate = useNavigate()
  const [isSubmit, setIsSubmit] = useState(false)
  const [form, setForm] = useState({
    email: '',
    password: ''
  })

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    })
  }

  const handleSubmit = async () => {
    if (!form.email || !form.password) {
      toast({
        title: 'Error',
        description: 'Input required fields.',
        position: 'top',
        status: 'warning',
        duration: 3000,
        isClosable: true
      })
    } else {
      setIsSubmit(true)
      try {
        const { token, exp } = await login(form.email, form.password)
        saveToken(token, exp)
        navigate('/')
        setIsSubmit(false)
      } catch (err) {
        toast({
          title: 'Error',
          description: JSON.stringify(err.response.data),
          position: 'top',
          status: 'error',
          duration: 3000,
          isClosable: true
        })
        setIsSubmit(false)
      }
    }
  }

  return (
    <Container
      display="flex"
      justifyContent="center"
      py="100px"
    >
      <Flex
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        maxW="400px"
        w="100%"
      >
        <Image w="220px" src={LogoV2} alt="logo" />
        <Card variant="outline" mt="50px" w="100%">
          <CardHeader>
            <Heading size="md">Login</Heading>
          </CardHeader>
          <CardBody>
            <FormControl>
              <FormLabel>Email</FormLabel>
              <Input type="email" name="email" value={form.email} onChange={handleChange} />
            </FormControl>
            <FormControl mt="10px">
              <FormLabel>Password</FormLabel>
              <Input type="password" name="password" value={form.password} onChange={handleChange} />
            </FormControl>
          </CardBody>
          <CardFooter justifyContent="space-between">
            <Button variant="ghost" colorScheme="blue" px="0px">Forget Password?</Button>
            <Button isLoading={isSubmit} colorScheme="blue" onClick={handleSubmit}>Login</Button>
          </CardFooter>
        </Card>
      </Flex>
    </Container>
  )
}
